import { useTranslation } from '@/shared/i18n/use-translation';
import { useSession } from './use-session';

/** Resolve user ids to display names ("Someone" for unknown ones). */
export function usePersonName(): (userId: string) => string {
  const session = useSession();
  const { t } = useTranslation();
  return function nameOf(userId) {
    return session?.people.find((person) => person.id === userId)?.display_name ?? t('Someone');
  };
}
